var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.375,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#F6F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26958 11.0058C8.40085 11.0056 8.53086 11.0342 8.6521 11.0898C8.77334 11.1454 8.88341 11.227 8.97597 11.3299L14.0893 16.9803C14.244 17.1513 14.4276 17.287 14.6298 17.3796C14.832 17.4721 15.0486 17.5198 15.2674 17.5198C15.4863 17.5198 15.7029 17.4721 15.9051 17.3796C16.1073 17.287 16.2909 17.1513 16.4456 16.9803L21.5509 11.3373C21.6431 11.2318 21.7534 11.1476 21.8754 11.0897C21.9974 11.0318 22.1285 11.0013 22.2612 11C22.394 10.9988 22.5256 11.0267 22.6484 11.0823C22.7713 11.1378 22.8829 11.2198 22.9768 11.3236C23.0706 11.4273 23.1448 11.5506 23.1951 11.6864C23.2454 11.8222 23.2706 11.9677 23.2695 12.1143C23.2683 12.261 23.2408 12.406 23.1884 12.5408C23.136 12.6756 23.0598 12.7975 22.9644 12.8994L17.8591 18.5424C17.1713 19.3011 16.2392 19.7273 15.2674 19.7273C14.2957 19.7273 13.3636 19.3011 12.6758 18.5424L7.56253 12.892C7.42265 12.7375 7.32737 12.5406 7.28876 12.3263C7.25016 12.1119 7.26995 11.8897 7.34565 11.6878C7.42134 11.4858 7.54953 11.3133 7.714 11.1919C7.87847 11.0705 8.07182 11.0057 8.26958 11.0058Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.646a20f908ea3a135d1273ce1a652ad6.svg";
export { ForwardRef as ReactComponent };